import React from "react";
import { useTheme } from "styled-components";

// Default decorative graphic used when the editor uploads no custom image.
// Small flat gift box in the brand's colours; sized by the parent (ImageBox).
const SovendusDefaultGraphic: React.FC = (): React.JSX.Element => {
  const { colors } = useTheme();
  const ink = colors.fontTextSemiLight;
  const ribbon = colors.primary;
  return (
    <svg viewBox="0 0 64 64" role="img" aria-label="Geschenk">
      <g
        fill={colors.white}
        stroke={ink}
        strokeWidth="3"
        strokeLinejoin="round"
      >
        <rect x="11" y="27" width="42" height="29" rx="3" />
        <rect x="7" y="17" width="50" height="11" rx="2" />
      </g>
      <rect x="29" y="17" width="6" height="39" fill={ribbon} />
      <path d="M32 17 C25 6 12 7 17 14 C20 18 28 17 32 17Z" fill={ribbon} />
      <path d="M32 17 C39 6 52 7 47 14 C44 18 36 17 32 17Z" fill={ribbon} />
    </svg>
  );
};

export default SovendusDefaultGraphic;
